<template>
  <div class="form">
    <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline;">HK6 - AKTIVITI BUKAN PERTANIAN DAN BUKAN ICT (LAIN-LAIN)</h1>
      
        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          :rules="rules"
          width="20px"
          disabled
        ></v-text-field>
  
      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            
            <v-spacer></v-spacer>
                <v-btn
                color="error"
                small
                @click="dialogPengesahan=true;"
                >
                  Padam
                </v-btn>
            </v-card-title>
            
            <v-data-table
              :headers="headers"
              :items="dataHK6"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            >
            <template v-slot:item.HK6A2= "{ item }">
            {{ formatNumber(item.HK6A2) }}
            </template>
            <template v-slot:item.HK6A3= "{ item }">
            {{ formatNumber(item.HK6A3) }}
            </template>
            <template v-slot:item.HK6A4= "{ item }">
            {{ formatNumber(item.HK6A4) }}
            </template>
            <template v-slot:item.HK6B1= "{ item }">
            {{ formatNumber(item.HK6B1) }}
            </template>
            <template v-slot:item.HK6B2= "{ item }">
            {{ formatNumber(item.HK6B2) }}
            </template>
            <template v-slot:item.HK6C1= "{ item }">
            {{ formatNumber(item.HK6C1) }}
            </template>
            <template v-slot:item.HK6C3= "{ item }">
            {{ formatNumber(item.HK6C3) }}
            </template>
            <template v-slot:item.HK6C4= "{ item }">
            {{ formatNumber(item.HK6C4) }}
            </template>
            <template v-slot:item.HK6INCS21e= "{ item }">
            {{ formatNumber(item.HK6INCS21e) }}
            </template>
            <template v-slot:item.HK6INCS21ei= "{ item }">
            {{ formatNumber(item.HK6INCS21ei) }}
            </template>
            <template v-slot:item.HK6INCS21eii= "{ item }">
            {{ formatNumber(item.HK6INCS21eii) }}
            </template>
            <template v-slot:item.HK6INCS21eiii= "{ item }">
            {{ formatNumber(item.HK6INCS21eiii) }}
            </template>
            
          </v-data-table>
      </v-card>   
    </v-card> 
  
  
  <v-card>
    <v-card-title>
      Pendapatan daripada bekerja sendiri (Lain-lain)
    </v-card-title>
  
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
  
        <!-- s24 -->
        <v-row v-show="showS24">
          <v-col >
          S24 : Apakah jenis pekerjaan anda atau ahli isi rumah? <strong>[PK]</strong>
          <v-autocomplete
              :items="masco"
              :item-text="item => item.kod +' - '+ item.keterangan"
              return-object
              outlined
              dense
              v-model="HK6PK"
              :rules="rules"
          ></v-autocomplete>
          </v-col>
        </v-row>
  
        <!-- s25 -->
        <v-row v-show="showS25">
          <v-col>
          S25 : Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
          <v-autocomplete
              :items='msic'
              :item-text="item => item.kod +' - '+ item.keterangan"
              return-object
              outlined
              dense
              v-model="HK6PN"
          ></v-autocomplete>
          </v-col>
        </v-row>
  
       <!-- s26 -->
        <v-row>
          <v-col>
          S26 : Nyatakan tempoh bagi soalan S24 <strong>[M]</strong>
            <v-row>
  
              <!-- tempoh -->
              <v-col cols="4">
                <v-autocomplete
                    min="0"
                    maxlength="2"
                    :items="tambahlookupbulan"
                    v-model="HK6M"
                    label="Tempoh(bulan)"
                    outlined
                    dense
                    :item-text="item => item.id"
                    item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
  
  
      <v-form ref="form2" :disabled="disabledInput">
        <!-- s38 -->
        <v-row>                                             
            <v-col cols="4">
            S38. Mempunyai akaun penyata kira-kira? 
            <v-select
                :items="yaTidak"
                item-text="desc"
                return-object
                solo
                dense
                v-model="HK6S38"
            ></v-select>          
            </v-col>                                 
        </v-row>
  
  <div v-show="soalanAkaunPenyataYa">
        <!-- s39 -->
        <v-row>
          <v-col>
            S39 : Tempoh penyata kira-kira (dalam bulan)
            <v-row>
                <v-col cols="4" sm="6" md="4">
                  <v-text-field
                        v-model="HK6S39"
                        label="bulan"
                        outlined
                        type="number"
                        dense
                  ></v-text-field>
                </v-col>
  
            </v-row>
          </v-col>
        </v-row>
  
        <!-- s40 -->
        <v-row v-show="showS40">
          <v-col>
            S40. Keuntungan bersih sebagaimana tercatat dalam penyata kira-kira dalam 12 bulan yang lalu <strong>[B1]</strong>                                                         
            <v-row>
              <v-col cols="4" sm="4" md="4">
                Tempoh Bekerja
                <v-text-field
                      v-model="HK6b1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
  
        <!-- s41 -->
        <v-row v-show="showS41">
          <v-col>
            S41. Anggaran keuntungan bersih berdasarkan penyata kira-kira tahun sebelum ini dalam 12 bulan yang lalu <strong>[B2]</strong> <v-row>
              <v-col cols="4" sm="4" md="4">
                Tempoh Bekerja
                <v-text-field
                      v-model="HK6b2"
                      label="RM"
                      outlined
                      type="number"
                      dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
  </div>
  
  <div v-show="soalanAkaunPenyataTidak">
        <!-- s61 -->
        <v-row>
          <v-col>
            S61. Nyatakan jumlah bulan berniaga dalam setahun <strong>[A1]</strong><v-row>
              <v-col cols="4" sm="4" md="4">
                Tempoh Bekerja
                <v-text-field
                      v-model="HK6a1"
                      label="Bulan"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
  
        <!-- s62 -->
        <v-row>
          <v-col>
            S62. Nyatakan purata penerimaan daripada jualan bulanan<strong>[A2]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6a2"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
  
        <!-- s63 -->
        <v-row>
          <v-col>
            S63. Purata perbelanjaan bulanan <br><strong>[A3]</strong>
            Termasuk gaji dan upah, sewa ruang pejabat, elektrik, bahan bakar, air, pembaikan dan penyelenggaraan, cukai tidak langsung misalnya cukai tanah, cukai pintu, dll., nilai barang-barang yang dibeli untuk dijual semula, harga pembelian barang-barang mentah dan perbelanjaan lain
            <v-row>
                <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6a3"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col>  
            </v-row>     
          </v-col>
        </v-row>
  </div>
  
        <!-- s64 -->
        <v-row>
          <v-col>
            S64. Purata keuntungan bersih bulanan <strong>[A4]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6a4"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col>
            </v-row>          
          </v-col>
        </v-row>
  
        <!-- s65 -->
        <v-row>
          <v-col>
            S65. Pendapatan bersih <strong>[C1]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6C1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col> 
            </v-row>         
          </v-col>
        </v-row>
  
              <v-row>
          <v-col>
            S66. Peratus pembahagian di C1 yang dipegang oleh ahli isi rumah <strong>[C2]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6C2"
                      label="%"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits3"
                ></v-text-field>
              </v-col> 
            </v-row>         
          </v-col>
        </v-row>
  
        <!-- s67 -->
        <v-row>
          <v-col>
            S67. Nilai mutlak bagi C2 <strong>[C3]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6C3"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col> 
            </v-row>         
          </v-col>
        </v-row>
  
        <!-- s68 -->
        <v-row>
          <v-col>
            S68. Anggaran barangan keluaran yang digunakan sendiri setahun dalam 12 bulan yang lalu <strong>[C4]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field
                      v-model="HK6C4"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col> 
            </v-row>         
          </v-col>
        </v-row>
  
        <!-- s69 -->
        <v-row>
          <v-col>
            S69. Pendapatan bersih yang diterima oleh isi rumah <strong>[C5]</strong>
            <v-row>
              <v-col cols="4" sm="4" md="4">
                <v-text-field                    
                      v-model="HK6INCS21e"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col>  
            </v-row>        
          </v-col>
        </v-row>
  
        <!-- s70-->
        <v-row>
          <v-col>
            S70. Pendapatan daripada C5: <br>          
            <v-row class="mt-2">
              <v-col cols="4" sm="4" md="4">
                i. Pendapatan lain dalam talian melalui transaksi e-dagang (cth: menerima pesanan melalui lazada, shopee, dll) <strong>[INCS21e(i)]</strong>
               
                <v-text-field
                      v-model="HK6INCS21ei"
                      label=RM
                      outlined
                      type="number"
                      persistent-hint
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
  
                
              </v-col>
  
              <v-col cols="4" sm="4" md="4">
                ii. Pendapatan lain dalam talian melalui transaksi bukan e-dagang (cth: menerima pesanan melalui whatsapp, emel, dll) <strong>[INCS21e(ii)]</strong>
              
                <v-text-field
                      v-model="HK6INCS21eii"
                      label=RM
                      outlined
                      type="number"
                      persistent-hint
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>  
              </v-col>
  
              <v-col cols="4" sm="4" md="4">
                iii. Pendapatan lain bukan dalam talian <strong>[INCS21e(iii)]</strong>
                <br>
                <br>
                <v-text-field
                      v-model="HK6INCS21eiii"
                      label=RM
                      outlined
                      type="number"
                      persistent-hint
                      dense
                      @keypress="limitDigits8"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
      </v-form>
  
        <!-- s37 -->
        <v-row>
          <v-col cols="6">
          S37 : Adakah anda atau ahli isi rumah mempunyai pekerjaan lain dalam tempoh 12 bulan yang lalu? <strong>[KL]</strong>
          <v-select
              :items="yaTidak"
              item-text="desc"
              return-object
              solo
              dense
              v-model="HK6KL"
          ></v-select>
          </v-col>
        </v-row>
  
    </v-card-text>
  
   
  <v-card-actions>
   <v-spacer></v-spacer>
      <v-btn
          text
          color="primary"
          @click='simpan()'
          v-show="butangSimpan"
      >
        Simpan
      </v-btn>
      <v-btn
        text
        color="primary"
        v-show="butangKemaskini"
        @click="updateHK6()"
      >
        Kemaskini
      </v-btn>
      <v-btn
        text
        color="primary"
        v-show="butangKemaskini"
        @click="goTo('2')"
      >
        Seterusnya
      </v-btn>
  </v-card-actions>
  </v-card>
  
   <v-alert
    prominent
    type="error"
    :value="popUpALert"
   >
    <v-row align="center" class="mb-2">
      <v-col class="grow">
        Adakah anda pasti untuk padam?
      </v-col>
      <v-col class="shrink">
        <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
        <v-btn @click="padam('2')">Cancel</v-btn>
      </v-col>
    </v-row>
  </v-alert>
      
  <!-- Error Dialog -->
  <v-dialog
        v-model="errorDialog"
        width="500"
        height="200"
      >
      <v-card>
        <v-alert
          dense
          outlined
          color="#C51162"
          type="error"
        >
        <strong>{{errMessage}}</strong>
        </v-alert>
      </v-card>
  </v-dialog>
  
  <!-- Success Dialog -->
  <v-dialog
        v-model="successDialog"
        max-width="800"
        height="200"
      >
      <v-card
        color="success"
      >
        <v-alert
          dense
          outlined
          color="#C51162"
          type="success"
        >
        <strong>{{successMessage}}</strong>
        </v-alert>
  
        <v-card-actions> 
          <v-spacer></v-spacer>
              <v-btn
                  color="warning"
                  @click='successDialog = false;'
              >
                Batal
              </v-btn>
              <v-btn
                color="primary"
                @click='goTo("2")'
              >
                Pengisian Seterusnya
              </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
  
  <!-- Kemaskini Dialog -->
  <v-dialog
        v-model="kemaskiniDialog"
        max-width="800"
        height="200"
      >
      <v-card
      >
        <v-alert
          dense
          solo
        >
        <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
        </v-alert>
      </v-card>
  </v-dialog>
  
  <!-- Pengesahan Padam Dialog -->
   <v-row justify="center">
      <v-dialog
        v-model="dialogPengesahan"
        persistent
        max-width="330"
      >
        <v-card>
          <v-card-text>
           <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
           {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
           <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              @click="dialogPengesahan = false;"
            >
             {{$t('batal')}}
            </v-btn>
            <v-btn
              color="error"
              @click="padamData()"
            >
              {{$t('padam')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  
  
  </div>
  </template>
  <script>
  import axios from '../../plugins/axios'
  //////////////////////////import services///////////////////
  import getLocalStorage from '@/services/getLocalStorage'
  const localStorageData = new getLocalStorage(); 
  
  import hidServices from "@/services/lookupField";
  const lookup = new hidServices();
  
  import lookupField from '@/services/lookupField'
  const lookupFieldServices = new lookupField();
  //////////////////////////end import services//////////////
  
  export default {
  
      async beforeMount(){
          
          var dataHID = localStorageData.getHIDdata()
  
          this.HID = dataHID.HID;
          this.BNO = dataHID.BNO;
          this.Ps = dataHID.P;
          this.S = dataHID.S;
          this.NG = dataHID.NG;
          this.DP = dataHID.DP;
          this.DB =  dataHID.DB;
          this.BP = dataHID.BP;
          this.ST = dataHID.ST;
          this.NOTK = dataHID.NOTK;
          this.NOAIR = dataHID.NOAIR;
          this.Bulan = dataHID.BULAN;
          this.Tahun = dataHID.TAHUN;
  
          this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
          this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
          this.yaTidak = lookupFieldServices.getYaTidak();
  
          this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
          this.NOAIR = this.currNOAIRData.NOAIR;
          
          this.getData();//dapatkan data based on HID
  
  
      },
      data: () => ({
          menu1:'',
          dateMula:'',
          menu2:'',
          dateTamat:'',
          butangSimpan: true,
          butangKemaskini: false,
          disabledInput : true,
          showS24: true,
          showS25: true,
          showS40 : false,
          showS41 : false,
  
          dialog: false,
          successDialog: false,
          errorDialog: false,
          successMessage:'',
          errMessage:'',
          message: "Saving Data",
          popUpALert:false,
          kemaskiniDialog: false,
          dialogPengesahan: false,
  
          search: '',
          currNOAIRData:'',
          masco:[],
          msic:[],
          yaTidak:[],
          selectedData: [],
  
          soalanAkaunPenyataYa:false,
          soalanAkaunPenyataTidak:false,
  
        
          /////////////////////data declaration//////////////////////////
          HID: '',
          KAW: 1,
          Bulan:'',
          Tahun:'',
          BNO:'',
          Ps:'',
          S:'',
          NG: '',
          DP:'',
          DB:'',
          BP:'',
          ST:'',
          NOTK:'',
          NOIR:'',
          R:1,
          
          HK6PK:'',
          HK6PN:'', 
          HK6M:'', 
          HK6S38:0,
          HK6S39:0,
          HK6b1:0,
          HK6b2:0, 
          HK6a1:0, 
          HK6a2:0, 
          HK6a3:0, 
          HK6a4:0, 
          HK6C1:0, 
          HK6C2:0, 
          HK6C3:0, 
          HK6C4:0, 
          HK621ei:0,
          HK621eii:0,
          HK621eiii:0,
          //HK6INCS21e:'', 
          HK6INCS21ei:0, 
          HK6INCS21eii:0, 
          HK6INCS21eiii:0, 
          HK6INCS21c:'', 
          HK6KL:'',        
          dataHK6: [],
           rules: {
            required: v => !!v || 'field is required',
            emel: (value) => {
              return /.+@.+\..+/.test(value) || 'E-mail must be valid'
            },
            percentage:(value)=>{
              return (value <= 100) || 'Percentage must between 1 - 100'
            },
            takmauPoint:(value)=>{
              return (value % 1 === 0)? true:'No point needed'
            }
            
          },
          headers: [
            {
              text: 'NOAIR',
              align: 'start',
              sortable: false,
              value: 'NOAIR',
            },
            { text: 'HID', value: 'HID' },
            { text: 'NOAIR', value: 'NOAIR' },
            { text: 'PK', value: 'HK6PK' },
            { text: 'PN', value: 'HK6PN' },
            { text: 'M', value: 'HK6M' },
            { text: 'S38', value: 'HK6S38' },
            { text: 'S39', value: 'HK6S39' },
            { text: 'B1', value: 'HK6B1' },
            { text: 'B2', value: 'HK6B2' }, 
            { text: 'A1', value: 'HK6A1' }, 
            { text: 'A2', value: 'HK6A2' }, 
            { text: 'A3', value: 'HK6A3' }, 
            { text: 'A4', value: 'HK6A4' }, 
            { text: 'C1', value: 'HK6C1' }, 
            { text: 'C2', value: 'HK6C2' }, 
            { text: 'C3', value: 'HK6C3' }, 
            { text: 'C4', value: 'HK6C4' }, 
            { text: 'INCS21e', value: 'HK6INCS21e' }, 
            { text: 'INCS21e(i)', value: 'HK6INCS21ei' }, 
            { text: 'INCS21e(ii)', value: 'HK6INCS21eii' }, 
            { text: 'INCS21e(iii)', value: 'HK6INCS21eiii' }, 
            { text: 'KL', value: 'HK6KL' },
           
  
          ],
         ///////////link untuk ke page/////////////////////
        breadcrumbs: [
          {
            text: 'Status Pengisian',
            disabled: false,
            href: 'ringkasanMaklumatIR',
          },
            {
            text: 'HK6',
            disabled: true,
            href: 'hk6',
          },
        ],
        valid: true,
        select: null,
        checkbox: false,
      }),
  
      methods: {
        formatNumber(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        stripCommas(value) {
          return value.replace(/,/g, '');
        },
        validate () {
          this.$refs.form.validate()
        },
        reset() {
          this.$refs.form.reset();
          this.$refs.form2.reset();
        },
        resetValidation () {
          this.$refs.form.resetValidation()
        },
        limitDigits8(event) {
        const value = event.target.value;
        if (value.length >= 8 ) {
            event.preventDefault();
          }
        },
        limitDigits2(event) {
        const value = event.target.value;
        if (value.length >= 2 ) {
            event.preventDefault();
          }
        },
        limitDigits3(event) {
        const value = event.target.value;
        if (value.length >= 3 ) {
            event.preventDefault();
          }
        },
        async simpan (){
      
          if (this.$refs.form.validate()){
              this.dialog =  true;
              setTimeout(() => (this.dialog = false), 2000)
           
              try {
  
              const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK6`, {
                HID: this.HID,
                NOAIR: this.NOAIR,
                KAW: this.KAW,
                Bulan: this.Bulan,
                Tahun: this.Tahun,
                IDBPK: this.IDBPK,
                HK6PK: this.HK6PK.kod,
                HK6PN: this.HK6PN.kod,
                // dateMula: this.dateMula,
                // dateTamat: this.dateTamat,  
                HK6M: this.HK6M, 
                HK6S38: this.HK6S38.id,
                HK6S39: this.HK6S39,
                HK6b1: this.HK6b1,
                HK6b2: this.HK6b2, 
                HK6a1: this.HK6a1, 
                HK6a2: this.HK6a2, 
                HK6a3: this.HK6a3, 
                HK6a4: this.HK6a4, 
                HK6C1: this.HK6C1, 
                HK6C2: this.HK6C2, 
                HK6C3: this.HK6C3, 
                HK6C4: this.HK6C4, 
                HK621ei: this.HK621ei, 
                HK621eii: this.HK621eii, 
                HK621eiii: this.HK621eiii, 
                HK6INCS21e: this.HK6INCS21e, 
                HK6INCS21ei: this.HK6INCS21ei, 
                HK6INCS21eii: this.HK6INCS21eii, 
                HK6INCS21eiii: this.HK6INCS21eiii, 
                HK6INCS21c: this.HK6INCS21c, 
                HK6KL: this.HK6KL.id,
              //////////total yang perlu diupdate ke jr5///////////
                  totalHK6INCS21e : this.totalHK6INCS21e,
                  totalHK6NCS21ei : this.totalHK6INCS21ei,
                  totalHK6INCS21eii : this.totalHK6INCS21eii,
                  totalHK6INCS21eiii : this.totalHK6INCS21eiii,
              
                })
                  this.res = res.data;
                  this.reset();
                  this.getData();
                  this.successMessage = 'Data Disimpan!';
                  this.successDialog = true;
                  window.scrollTo(0, 0);
                  
              } catch (error) {
                //console.log(error)
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = 'Simpan : '+error;
              }
          }else{
            window.scrollTo(0, 0);
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Please fill in the field!';
          }
        },
        async updateHK6(){
      
              try {
                  const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK6`, {
                  
                  HID: this.HID,
                  NOAIR: this.NOAIR,
                  KAW: this.KAW,
                  Bulan: this.Bulan,
                  Tahun: this.Tahun,
                  IDBPK: this.IDBPK,
                  HK6PK: this.HK6PK,
                  HK6PN: this.HK6PN,
                  // dateMula: this.dateMula,
                  // dateTamat: this.dateTamat, 
                  HK6M: this.HK6M, 
                  HK6S38: this.HK6S38.id,
                  HK6S39: this.HK6S39,
                  HK6b1: this.HK6b1,
                  HK6b2: this.HK6b2, 
                  HK6a1: this.HK6a1, 
                  HK6a2: this.HK6a2, 
                  HK6a3: this.HK6a3, 
                  HK6a4: this.HK6a4, 
                  HK6C1: this.HK6C1, 
                  HK6C2: this.HK6C2, 
                  HK6C3: this.HK6C3, 
                  HK6C4: this.HK6C4, 
                  HK621ei: this.HK621ei, 
                  HK621eii: this.HK621eii, 
                  HK621eiii: this.HK621eiii, 
                  HK6INCS21e: this.HK6INCS21e, 
                  HK6INCS21ei: this.HK6INCS21ei, 
                  HK6INCS21eii: this.HK6INCS21eii, 
                  HK6INCS21eiii: this.HK6INCS21eiii, 
                  HK6INCS21c: this.HK6INCS21c, 
                  HK6KL: this.HK6KL.id,
  
                  //////////total yang perlu diupdate ke jr5///////////
                  totalHK6INCS21e : this.totalHK6INCS21e,
                  totalHK6INCS21ei : this.totalHK6INCS21ei,
                  totalHK6INCS21eii : this.totalHK6INCS21eii,
                  totalHK6INCS21eiii : this.totalHK6INCS21eiii,
  
  
                })
                  this.res = res.data;
                  this.reset();
                  this.getData();
                  this.butangKemaskini = false;
                  this.successMessage = 'Data Dikemaskini!';
                  this.successDialog = true;
                  window.scrollTo(0, 0);
                  
              } catch (error) {
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = 'Simpan : '+error;
              }
  
          
        },
        async padamData(){
  
          try {
                  const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                  HID:  this.HID,
                  NOAIR: this.NOAIR,
                  table: "HK6"
                })
                  this.res = res.data;
                  this.reset();
                  this.dialogPengesahan = false;
                  this.successDialog = true;
                  setTimeout(() => (this.successDialog = false), 2000);
                  this.successMessage = 'Data Dipadam!'
                  this.getData(); 
                
              } catch (error) {
                //console.log(error)
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = 'Padam : '+error;
              }  
        },
        async getData(){
          //dapatkan data dari table HK6 based on HID
     
          try {
              const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK6?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
              })
              //var dataz = res.data.data
              this.dataHK6 = res.data.data;
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'getData : '+ error;
            }
        },
        handleClick(row) {
            console.log(row)
            this.selectedData = [];
            this.selectedData = row;
  
            this.kemaskiniDialog = true;
            setTimeout(() => (this.kemaskiniDialog = false), 1000);
  
            this.showS24 = false;
            this.showS25 = false;
            this.butangSimpan = false;
            this.butangKemaskini = true;
  
            this.NOAIR = row.NOAIR;
            this.HK6PK = row.HK6PK;
            this.HK6PN = row.HK6PN;
            // this.dateMula = row.dateMula;
            // this.dateTamat = row.dateTamat;
            this.HK6M = row.HK6M;
            this.HK6S38 = row.HK6S38;
            this.HK6S39 = row.HK6S39;
            this.HK6a1 = row.HK6A1;
            this.HK6a2 = this.stripCommas(row.HK6A2);
            this.HK6a3 = this.stripCommas(row.HK6A3);
            this.HK6a4 = this.stripCommas(row.HK6A4);
            this.HK6b1 = this.stripCommas(row.HK6B1);
            this.HK6b2 = this.stripCommas(row.HK6B2);
            this.HK6C1 = this.stripCommas(row.HK6C1);
            this.HK6C2 = row.HK6C2;
            this.HK6C3 = this.stripCommas(row.HK6C3);
            this.HK6C4 = this.stripCommas(row.HK6C4);
            this.HK6INCS21ei = this.stripCommas(row.HK6INCS21ei);
            this.HK6INCS21eii = this.stripCommas(row.HK6INCS21eii);
            this.HK6INCS21eiii = this.stripCommas(row.HK6INCS21eiii);
            this.HK6INCS21e = this.stripCommas(row.HK6INCS21e);


            // this.HK6KL= row.HK6KL;  
  
            if(row.HK6S38 == 1){
              this.HK6S38 = this.yaTidak[0];
            }
            if(row.HK6S38 == 2){
              this.HK6S38 = this.yaTidak[1];
            }
  
            if(row.HK6KL == 1){
              this.HK6KL = this.yaTidak[0];
            }
            if(row.HK6KL == 2){
              this.HK6KL = this.yaTidak[1];
            }
                  
           
        },
        // kiraTempoh(){
          
        //   var d1 = new Date(this.dateMula);
        //   var d2 = new Date(this.dateTamat);
          
        //   var months;
        //   months = (d2.getFullYear() - d1.getFullYear()) * 12;
        //   months -= d1.getMonth();
        //   months += d2.getMonth();
        //   this.HK6M = months;
  
        //   // if(months <= 0){
        //   //   // To calculate the time difference of two dates
        //   //   var Difference_In_Time = d2.getTime() - d1.getTime();
              
        //   //   // To calculate the no. of days between two dates
        //   //   var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        //   //   months = '0.'+Difference_In_Days
        //   //   console.log(months)
        //   // }else{
        //   //   console.log(months)
        //   // }
          
        //   // return months <= 0 ? 0 : months;
        // },
        goTo(option){
  
          if(option == "1"){
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
  
          if(option == "2"){
        
            if(this.HK6KL.id == "1"){
              this.$router.push({name: "JRB"});
            }
            if(this.HK6KL.id == "2"){
              this.$router.push({name: "ringkasanMaklumatIR"});
            }
           
          }   
        }
      },
      watch:{
        HK6S38(val){
          var valueS38 = val.id;
          if(valueS38 == 1){
            //setkan value s42,s43 jadi 0
            this.HK6a1 = 0;
            this.HK6a2 = 0;
            this.HK6a3 = 0;
  
            this.soalanAkaunPenyataYa = true;
            this.soalanAkaunPenyataTidak = false;
          }
          if(valueS38 == 2){
            //setkan soalan s39,s40,s41 jadi 0
            this.HK6S39 = 0;
            this.HK6b1 = 0;
            this.HK6b2 = 0;
            this.soalanAkaunPenyataYa = false;
            this.soalanAkaunPenyataTidak = true;
          }
  
        },
        HK6S39(){
          if(this.HK6S39 >=6){
            this.showS40 = true;
            this.showS41 = false;
          }else{
            this.showS40 = false;
            this.showS41 = true;
          }
        },
        // HK621ei(){
        //   this.HK6INCS21ei = Number(this.HK621ei)*Number(this.HK6INCS21e)/100;
        // },
        // // HK621eii(){
        // //   this.HK6INCS21eii = Number(this.HK621eii)*Number(this.HK6INCS21e)/100;
        // // },
        // HK621eiii(){
        //   this.HK6INCS21eiii = Number(this.HK621eiii)*Number(this.HK6INCS21e)/100;
        // },
        // HK6a3(){
        //   this.HK6a4 = Number(this.HK6a2)-Number(this.HK6a3);
        // },
        // HK6b1(){
        //   this.HK6C1 = this.HK6b1;
        // },
        // HK6b2(){
        //   this.HK6C1 = this.HK6b2;
        // },
        // HK6a4(){
        //   this.HK6C1 = Number(this.HK6a4) * Number(this.HK6a1);
        // },
        // HK6C2(){
        //   this.HK6C3 = Number(this.HK6C1) * Number(this.HK6C2)/100;
        // },
        // HK6C4(){
        //   this.HK6INCS21e = Number(this.HK6C3) + Number(this.HK6C4);
        // },
        // HK621eii(){
        //   this.HK6INCS21eii = Number(this.HK621eii)*Number(this.HK6INCS21e)/100;
  
        //   this.HK621eiii = Number(this.HK621ei) + Number(this.HK621eii);
        //   this.HK621eiii = 100 - Number(this.HK621eiii);
        // },
        HK6M(val){
      
          if(isNaN(val)){
              this.disabledInput = true;
            }else{
              this.disabledInput = false;
          }
        },
       
      },
      computed:{
        // HK6M: function(){
        //   var d1 = new Date(this.dateMula);
        //   var d2 = new Date(this.dateTamat);
          
        //   var months;
        //   months = (d2.getFullYear() - d1.getFullYear()) * 12;
        //   months -= d1.getMonth();
        //   months += d2.getMonth()+1;
          
        //     if(months > 12){
        //       return 12
        //     }else{
        //       return months
        //     }
        // },
        // Msebenar: function(){
        //     var d1 = new Date(this.dateMula);
        //     var d2 = new Date(this.dateTamat);
            
        //     var months = 0;
        //     months = (d2.getFullYear() - d1.getFullYear()) * 12;
        //     months -= d1.getMonth();
        //     months += d2.getMonth()+1;
  
        //     return months;
        // },
        HK6INCS21e: function(){
          return Number(this.HK6C3) + Number(this.HK6C4);
        },
        totalHK6INCS21e:  function(){
            var total = 0;
            if(this.dataHK6.length >= 1){
              ///calculate semua value HK6INCS21a yang telah di insert
              for(var i = 0; i < this.dataHK6.length ; i++){
                total = total + Number(this.dataHK6[i].HK6INCS21e)
              }
            }
  
            ///tambahkan total yang telah diinsert dengan current HK6INCS21a yang bakal diinsert
            //total = total + Number(this.HK6INCS21e) - Number(this.selectedData.HK6INCS21e);
            if(this.selectedData.HK6INCS21e){
                total = total + Number(this.HK6INCS21e) - Number(this.selectedData.HK6INCS21e);
            }else{
                total = total + Number(this.HK6INCS21e) ;
            }
            return total;
        }, 
        tambahlookupbulan() {
        return lookup.getBulan();
        },
        totalHK6INCS21ei:  function(){
  
            var total = 0;
            if(this.dataHK6.length >= 1){
              ///calculate semua value totalHK6INCS21ei yang telah di insert
              for(var i = 0; i < this.dataHK6.length ; i++){
                total = total + Number(this.dataHK6[i].HK6INCS21ei)
              }
            }
  
            ///tambahkan total yang telah diinsert dengan current totalHK6INCS21ei yang bakal diinsert
            //total = total + Number(this.HK6INCS21ei) - Number(this.selectedData.HK6INCS21ei);
            if(this.selectedData.HK6INCS21ei){
                total = total + Number(this.HK6INCS21ei) - Number(this.selectedData.HK6INCS21ei);
            }else{
                total = total + Number(this.HK6INCS21ei) ;
            }
            return total;
  
        }, 
        totalHK6INCS21eii:  function(){
  
            var total = 0;
            if(this.dataHK6.length >= 1){
              ///calculate semua value HK6INCS21eii yang telah di insert
              for(var i = 0; i < this.dataHK6.length ; i++){
                total = total + Number(this.dataHK6[i].HK6INCS21eii)
              }
            }
  
            ///tambahkan total yang telah diinsert dengan current HK6INCS21eii yang bakal diinsert
            //total = total + Number(this.HK6INCS21eii) - Number(this.selectedData.HK6INCS21eii);
            if(this.selectedData.HK6INCS21eii){
                total = total + Number(this.HK6INCS21eii) - Number(this.selectedData.HK6INCS21eii);
            }else{
                total = total + Number(this.HK6INCS21eii) ;
            }
            return total
  
        }, 
        totalHK6INCS21eiii:  function(){
  
           var total = 0;
           if(this.dataHK6.length >= 1){
            ///calculate semua value HK6INCS21eiii yang telah di insert
            for(var i = 0; i < this.dataHK6.length ; i++){
              total = total + Number(this.dataHK6[i].HK6INCS21eiii)
            }
           }
  
            ///tambahkan total yang telah diinsert dengan current HK6INCS21eiii yang bakal diinsert
            //total = total + Number(this.HK6INCS21eiii) - Number(this.selectedData.HK6INCS21eiii);
            if(this.selectedData.HK6INCS21eiii){
                total = total + Number(this.HK6INCS21eiii) - Number(this.selectedData.HK6INCS21eiii);
            }else{
                total = total + Number(this.HK6INCS21eiii) ;
            }
            return total
  
        }, 
      }
  }
  </script>
  
  <style>
  #app {
    background: url('~@/assets/HIES.jpg')
    no-repeat center center fixed !important;
    background-size: cover;
  }
  
  </style>